import chart from 'components/chart/chart'
import marketService from 'services/market'
import { formatNumber } from 'utils/format-number'
import addOnclickToImg from './components/enlarge-blog-img'

const $tabs = document.querySelectorAll<HTMLAnchorElement>('[data-forex-tab]')
const $currency = document.querySelector<HTMLSpanElement>('[data-forex-currency]')
const $rate = document.querySelector<HTMLSpanElement>('[data-forex-rate]')
const $timestamp = document.querySelector<HTMLSpanElement>('[date-forex-timestamp]')
const $href = document.querySelector<HTMLAnchorElement>('[data-forex-href]')
const initCurrency = 'EUR'

init()

function init() {
  marketService.fetchRates()
  setInterval(marketService.fetchRates, 10 * 1000)
  initChart()
  $tabs.forEach(registerTabEvent)
  window.addEventListener('marketBrief fetched', updateTimeStamp)
  window.addEventListener('marketBrief fetched', updateRate)
  addOnclickToImg()
}

function initChart(): void {
  chart.init({
    element: 'forex-chart',
    currency: initCurrency,
    bank: 'ik',
    direction: 'avg',
    timeRange: '1-day',
  })
}

function registerTabEvent(tab: HTMLAnchorElement): void {
  tab.addEventListener('click', onTabChange)
}

function onTabChange(event): void {
  const currency = event.currentTarget.dataset.forexTab
  setActiveTab(event.currentTarget)
  updateChart(currency)
  updateCurrencyPair(currency)
  updateRate()
  setHref(event.currentTarget.dataset.forexRedirect)
}

function updateChart(currency: string): void {
  chart.config.currency = currency
  chart.singleChart()
}

function updateCurrencyPair(currency: string): void {
  $currency.innerHTML = currency
}

function getDateFormat00(n: number): string {
  return (n < 10 ? '0' : '') + n
}

function updateTimeStamp(): void {
  const now = new Date()
  const year = now.getFullYear()
  const month = getDateFormat00(now.getMonth() + 1) // 0-indexed
  const day = getDateFormat00(now.getDate())
  const hour = getDateFormat00(now.getHours())
  const minutes = getDateFormat00(now.getMinutes())
  $timestamp.innerHTML = `${year}-${month}-${day} ${hour}:${minutes}`
}

function updateRate(): void {
  const pair = marketService.getMarketBrief().find((el) => el.pair === `${$currency.innerHTML}_PLN`)
  const rate = pair?.directExchangeOffers.forexNow || 0
  $rate.innerHTML = formatNumber(rate, 4)
}

function setActiveTab(tab: HTMLAnchorElement): void {
  $tabs.forEach(resetActiveTab)
  tab.classList.add('active')
}

function resetActiveTab(tab: HTMLAnchorElement): void {
  tab.classList.remove('active')
}

function setHref(href: string): void {
  $href.setAttribute('href', href)
}
